export const SNACKBAR_EVENTS = {
  SHOW: 'snackbar:show'
};
